import { gql } from '@apollo/client';

export const getConsentTypes = gql`
  query getConsentTypes {
    consentTypes(filter: { state: { _eq: ACTIVE } }) {
      totalCount
      edges {
        node {
          id
          oid
          name
        }
      }
    }
  }
`;
